import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { WINS } from "./data";
import { Reveal } from "./Reveal";

function CountUp({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    const controls = animate(0, value, {
      duration: 1.7,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <strong ref={ref}>
      {display}
      {suffix}
    </strong>
  );
}

export function Metrics() {
  return (
    <section className="metrics page-width" data-testid="impact-metrics">
      <div className="section-kicker">The short version</div>
      <div className="metric-grid">
        {WINS.map((win, i) => (
          <Reveal className="metric" delay={i * 0.08} key={win.label} data-testid={`metric-${win.value}${win.suffix}`}>
            <CountUp value={win.value} suffix={win.suffix} />
            <span>{win.label}</span>
            <p>{win.detail}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
